import setCurrentPage from "src/Utils/setCurrentPage";

const DATA_NO_DEMO_ILO2 = {
  title:
    "Alarm identification —\nintegration with the alarm\ntriggering system",
  subtitle: "Network operations demo",
  text: '<span style="font-weight:bold">OpEx cost reduction</span> — proactively \nidentifying the alarm and taking the next step \nof action.',
  label: { iconPath: "start.png", text: "End to End Process View" },
  next: {
    label: "CONTINUE",
    onClick: () => setCurrentPage("ILO_207"),
    endIcon: "arrow-right",
  },
  back: {
    label: "BACK",
    onClick: () => setCurrentPage("ILO_205"),
    type: "transparent" as "transparent",
    startIcon: "arrow-left",
  },
  bgImage: "ILO/ILO2/ILO2_demo_screens_base.png",
  rightSideVideo: "ILO/ILO2/INF_CMT_827.23_Network Demo_Part 3_R1.mp4",
  pageNumber: "ILO_206",
};

export default DATA_NO_DEMO_ILO2;
